module.exports = __webpack_public_path__ + "static/media/20170806_44day_2094AT.db950665.jpg";